import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { setMessage } from '../message';
import HargaService from '../../services/hargaServices';
import { clearAuth } from 'store/auth';

export const getList = createAsyncThunk(
  'harga/list',
  async (
    {
      page,
      perPage,
      sort,
      orderBy,
      search,
      student_type_id,
      subscription_type_id,
      class_type_id,
      school_type_id,
      tahun_ajaran_id,
      jenjang_id,
      cabang_id
    },
    thunkAPI
  ) => {
    try {
      const response = await HargaService.getList(
        page,
        perPage,
        sort,
        orderBy,
        search,
        student_type_id,
        subscription_type_id,
        class_type_id,
        school_type_id,
        tahun_ajaran_id,
        jenjang_id,
        cabang_id
      );
      return response.data;
    } catch (error) {
      if (error.response.status == 401) {
        thunkAPI.dispatch(clearAuth());
      }
      const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
      thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const getListArchive = createAsyncThunk(
  'harga/getListArchive',
  async (
    {
      page,
      perPage,
      sort,
      orderBy,
      search,
      student_type,
      subscription_type,
      class_type,
      school_type,
      tahun_ajaran_id,
      jenjang_id,
      cabang_id
    },
    thunkAPI
  ) => {
    try {
      const response = await HargaService.getListArchive(
        page,
        perPage,
        sort,
        orderBy,
        search,
        student_type,
        subscription_type,
        class_type,
        school_type,
        tahun_ajaran_id,
        jenjang_id,
        cabang_id
      );
      return response.data;
    } catch (error) {
      if (error.response.status == 401) {
        thunkAPI.dispatch(clearAuth());
      }
      const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
      thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const createData = createAsyncThunk('harga/create', async (data, thunkAPI) => {
  try {
    const response = await HargaService.create(data);

    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
   
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const readData = createAsyncThunk('harga/read', async (id, thunkAPI) => {
  try {
    const response = await HargaService.read(id);
    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const updateData = createAsyncThunk('harga/update', async (data, thunkAPI) => {
  try {
    const response = await HargaService.update(data.id, data);

    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
   
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const deleteData = createAsyncThunk('harga/delete', async (id, thunkAPI) => {
  try {
    const response = await HargaService.del(id);

    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const changeStatus = createAsyncThunk('harga/changeStatus', async (data, thunkAPI) => {
  try {
    const response = await HargaService.changeStatus(data.id, data);
    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

const initialState = { isLoading: false, list: [], data: [], error: [] };

const hargaSlice = createSlice({
  name: 'harga',
  initialState,
  extraReducers: (builder) => {
    builder.addCase(getList.pending, (state) => {
      state.isLoading = true;
    }),
      builder.addCase(getList.fulfilled, (state, action) => {
        state.isLoading = false;
        state.list = action.payload;
      }),
      builder.addCase(getList.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(getListArchive.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(getListArchive.fulfilled, (state, action) => {
        state.isLoading = false;
        state.list = action.payload;
      }),
      builder.addCase(getListArchive.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(createData.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(createData.fulfilled, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(createData.rejected, (state, action) => {
        state.isLoading = false;
        state.error = Object.values(action.payload?.errors ?? {}).length > 0 ? action.payload.errors : [];
      }),
      builder.addCase(readData.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(readData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      }),
      builder.addCase(readData.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(updateData.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(updateData.fulfilled, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(updateData.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload.errors;
      }),
      builder.addCase(deleteData.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(deleteData.fulfilled, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(deleteData.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(changeStatus.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(changeStatus.fulfilled, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(changeStatus.rejected, (state) => {
        state.isLoading = false;
      });
  }
});

const { reducer } = hargaSlice;
export default reducer;
